export default {
    welcome: "Welcome to your store.",
    welcomeMsg: "Before your store opens, you need to go through a few steps so that your products can find their way to customers.",
    products: {
        title: "Products",
        noProducts: "Currently there's no products in your store.",
        hasProducts: "You have successfully added your first product.",
        manageProducts: "You can manage your products directly on page",
        addProducts: "Add products",
        buttonLabel: "Products"
    },
    delivery: {
        title: "Delivery",
        noDelivering: "You are not currently delivering your products.",
        addCities: "Add the cities where you deliver",
        hasDelivering: "You have successfully chosen cities where you deliver.",
        manageCities: "You can manage deliveries directly on page",
        buttonLabel: "Delivery"
    },
    verification: {
        title: "Verify your store",
        fewStepsMore: "A few more steps separate you from starting a sale.",
        companyDetails: "Enter basic details about your company to verify it and make it visible to customers.",
        help: "",
        readyForSale: "If you haven’t already, you can add products and delivery cities to be ready for sale after verifying your store.",
        verifyButton: "Verification"
    },
    hereLink: "here"
}
